import { CartAddEvent } from '@theme/events';

class ProductComplementaryThumbnails extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const { signal } = this.controller;
    const track = this.querySelector('ul');
    const dialog = this.querySelector('dialog');
    const content = dialog.querySelector('[data-modal-content]');
    dialog.querySelector('.complementary-modal__close').addEventListener('click', () => dialog.close(), { signal });
    let outsideDown = false;
    const outside = (event) => {
      const rect = dialog.getBoundingClientRect();
      return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
    };
    dialog.addEventListener('pointerdown', (event) => { outsideDown = outside(event); }, { signal });
    dialog.addEventListener('click', (event) => {
      if (outsideDown && outside(event)) dialog.close();
      outsideDown = false;
    }, { signal });
    track.addEventListener('click', (event) => {
      if (event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('[data-modal-product]');
      if (!link) return;
      event.preventDefault();
      const template = this.querySelector(`[data-product-template="${link.dataset.modalProduct}"]`);
      content.replaceChildren(template.content.cloneNode(true));
      dialog.showModal();
      const select = content.querySelector('select');
      const submit = content.querySelector('[type="submit"]');
      const updateVariant = () => {
        const option = select.selectedOptions[0];
        content.querySelector('[data-modal-price]').textContent = option.dataset.price;
        submit.disabled = option.dataset.available !== 'true';
        submit.textContent = submit.disabled ? 'Loppuunmyyty' : 'Lisää ostoskoriin';
      };
      updateVariant();
      select.addEventListener('change', updateVariant);
      content.querySelector('form').addEventListener('submit', async (submitEvent) => {
        submitEvent.preventDefault();
        submit.disabled = true;
        const status = content.querySelector('[data-modal-status]');
        status.textContent = 'Lisätään…';
        const body = new FormData(submitEvent.currentTarget);
        const sections = [...document.querySelectorAll('cart-items-component[data-section-id]')].map((item) => item.dataset.sectionId);
        body.set('sections', [...new Set(sections)].join(','));
        body.set('sections_url', window.location.pathname);
        try {
          const response = await fetch(Theme.routes.cart_add_url, { method: 'POST', body, headers: { Accept: 'application/json' } });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || 'Tuotteen lisääminen epäonnistui.');
          status.textContent = 'Tuote lisätty ostoskoriin.';
          dialog.close();
          this.dispatchEvent(new CartAddEvent({}, select.value, { source: 'product-form-component', itemCount: Number(body.get('quantity')), productId: link.dataset.modalProduct, sections: result.sections }));
        } catch (error) {
          status.textContent = error.message || 'Tuotteen lisääminen epäonnistui. Yritä uudelleen.';
        } finally {
          updateVariant();
        }
      });
    }, { signal });
    const arrows = this.querySelector('.product-complementary-thumbnails__arrows');
    const buttons = [...arrows.querySelectorAll('button')];
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      arrows.hidden = max <= 1;
      buttons[0].disabled = track.scrollLeft <= 1;
      buttons[1].disabled = track.scrollLeft >= max - 1;
    };
    buttons.forEach((button) => button.addEventListener('click', () => {
      const step = track.firstElementChild.getBoundingClientRect().width + 12;
      track.scrollBy({ left: Number(button.dataset.direction) * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }, { signal }));
    let drag;
    let suppressClick = false;
    track.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      suppressClick = false;
      drag = { id: event.pointerId, x: event.clientX, left: track.scrollLeft };
    }, { signal });
    track.addEventListener('pointermove', (event) => {
      if (!drag || event.pointerId !== drag.id) return;
      const distance = event.clientX - drag.x;
      if (!suppressClick && Math.abs(distance) < 5) return;
      suppressClick = true;
      track.classList.add('is-dragging');
      track.setPointerCapture(event.pointerId);
      track.scrollLeft = drag.left - distance;
      event.preventDefault();
    }, { signal });
    const endDrag = () => {
      drag = null;
      track.classList.remove('is-dragging');
    };
    window.addEventListener('pointerup', endDrag, { signal });
    track.addEventListener('pointercancel', endDrag, { signal });
    track.addEventListener('lostpointercapture', endDrag, { signal });
    track.addEventListener('dragstart', (event) => event.preventDefault(), { signal });
    track.addEventListener('click', (event) => {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }, { capture: true, signal });
    track.addEventListener('scroll', update, { passive: true, signal });
    this.observer = new ResizeObserver(update);
    this.observer.observe(track);
    update();
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
  }
}

if (!customElements.get('product-complementary-thumbnails')) {
  customElements.define('product-complementary-thumbnails', ProductComplementaryThumbnails);
}
